import cleanedFilename from '~/util/cleanedFilename';

export default {
  DELETE_ATTACHMENT_BUTTON: `${cleanedFilename(
    __filename,
  )}-delete-attachment-button`,
  UPLOADING: `${cleanedFilename(__filename)}-uploading`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
};
